export default function Footer() {
  return (
    <h5 className="text-center text-white bg-dark p-4">
      OEE Calculator | Built by Meliza Rose Alvarez
    </h5>
  );
}
